// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"33d6e0c9","878":"2cb21f71"}[chunkId] + ".chunk.js";
};